mutation UploadImage($input: UploadImageInput!) {
  file: uploadImage(input: $input) {
    id
    url
  }
}
